module.exports = __webpack_public_path__ + "static/media/logo134.80b2f104.png";